import { Box, Grid, GridItem } from '@chakra-ui/react';
import { Typography } from '@sgi/gravity';
import CreateContactForm from './CreateContactForm';

export const CreateContact = () => {
  function handleSelect() {}
  return (
    <>
      <Box bg="#FFFFFF" w="100%" p={9}>
        <Grid templateColumns="repeat(3, 1fr)">
          <GridItem colSpan={1}>
            <Typography variant="h1">Create Contact</Typography>
          </GridItem>
        </Grid>
      </Box>
      <Box pl="40px" pr="40px" pt={4}>
        <Box bg="white" w="100%" borderRadius={8}>
          <CreateContactForm
            parentType={'Page'}
            handleSelectContact={handleSelect}
          />
        </Box>
      </Box>
    </>
  );
};

export default CreateContact;
